import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  ArrowRight,
  Home,
  Wrench,
  Droplets,
  CloudLightning,
  ShieldCheck,
  Hammer,
  Search,
  FileText,
  Building2,
  AlertTriangle,
  Info,
  CheckCircle2,
} from "lucide-react";
import { SEOHead } from "@/components/SEOHead";

export default function Services() {
  const servicesSchema = {
    "@context": "https://schema.org",
    "@type": "RoofingContractor",
    "@id": "https://www.saskroofingcompany.com/services#webpage",
    name: "Sask Roofing Company — All Roofing Services",
    isPartOf: { "@id": "https://www.saskroofingcompany.com/#website" },
    about: { "@id": "https://www.saskroofingcompany.com/#localbusiness" },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Sask Roofing Company Services",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Asphalt Shingle Roofing",
            url: "https://www.saskroofingcompany.com/services/asphalt",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Metal Roofing",
            url: "https://www.saskroofingcompany.com/services/metal",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Roof Repair",
            url: "https://www.saskroofingcompany.com/services/repair",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Roof Replacement",
            url: "https://www.saskroofingcompany.com/services/replacement",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Storm & Hail Damage Repair",
            url: "https://www.saskroofingcompany.com/services/storm-damage",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Commercial Roofing",
            url: "https://www.saskroofingcompany.com/services/commercial",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Roof Inspections",
            url: "https://www.saskroofingcompany.com/services/inspections",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Eavestrough & Gutters",
            url: "https://www.saskroofingcompany.com/services/eavestrough",
          },
        },
      ],
    },
  };

  const services = [
    {
      id: "asphalt",
      title: "Asphalt Shingle Roofing",
      desc: "High-quality architectural shingles designed for high winds and extreme temperature changes.",
      image:
        "https://wsrv.nl/?url=https://vibe.filesafe.space/1783106672919603654/assets/85b773f8-7f79-4571-9209-d4d7c78ad49e.png&output=webp&q=60",
      icon: Home,
      link: "/services/asphalt",
    },
    {
      id: "metal",
      title: "Metal Roofing",
      desc: "Premium metal roof systems offering unmatched durability and a lifespan of 50+ years.",
      image:
        "https://wsrv.nl/?url=https://vibe.filesafe.space/1783106672919603654/assets/08fa6b00-3294-4b2b-8f95-21c9a5f68f33.png&output=webp&q=60",
      icon: ShieldCheck,
      link: "/services/metal",
    },
    {
      id: "repair",
      title: "Roof Repair",
      desc: "Fast, reliable leak diagnosis and repair to stop water damage before it spreads.",
      image:
        "https://wsrv.nl/?url=https://vibe.filesafe.space/1783106672919603654/assets/2b96a6b5-e087-4ce9-aaed-3f22cce04884.png&output=webp&q=60",
      icon: Wrench,
      link: "/services/repair",
    },
    {
      id: "replacement",
      title: "Roof Replacement",
      desc: "Complete roofing systems built for the prairie climate, with honest assessments and transparent pricing.",
      image:
        "https://wsrv.nl/?url=https://vibe.filesafe.space/1783106672919603654/assets/6bdf64c8-68f8-4072-8b33-467b923bb6af.png&output=webp&q=60",
      icon: Hammer,
      link: "/services/replacement",
    },
    {
      id: "storm",
      title: "Storm & Hail Damage",
      desc: "Emergency tarping, thorough inspections, and insurance claim assistance for storm restoration.",
      image:
        "https://wsrv.nl/?url=https://vibe.filesafe.space/1783106672919603654/assets/d8085d3a-0ecc-4476-b964-0564d85ab824.png&output=webp&q=60",
      icon: CloudLightning,
      link: "/services/storm-damage",
    },
    {
      id: "commercial",
      title: "Flat & Commercial Roofing",
      desc: "TPO, EPDM, and modified bitumen systems for flat roofs and commercial buildings.",
      image:
        "https://wsrv.nl/?url=https://vibe.filesafe.space/1783106672919603654/assets/d37fd459-ae0d-4cfc-ba9f-893acbc81058.png&output=webp&q=60",
      icon: Building2,
      link: "/services/commercial",
    },
    {
      id: "inspections",
      title: "Roof Inspections",
      desc: "Thorough, honest roof inspections to catch small problems before they become expensive disasters.",
      image:
        "https://wsrv.nl/?url=https://vibe.filesafe.space/1783106672919603654/assets/99f66784-13b7-421c-854f-0ebe217f35a6.png&output=webp&q=60",
      icon: Search,
      link: "/services/inspections",
    },
    {
      id: "eavestrough",
      title: "Eavestrough & Gutters",
      desc: "Seamless gutter installation to properly direct water away from your foundation.",
      image:
        "https://wsrv.nl/?url=https://vibe.filesafe.space/1783106672919603654/assets/f9c77778-c660-4ef2-bf94-0935a8c2d147.png&output=webp&q=60",
      icon: Droplets,
      link: "/services/eavestrough",
    },
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <SEOHead
        title="Roofing Services in Saskatchewan | Sask Roofing Company"
        description="Comprehensive roofing services including asphalt shingle, metal roofing, repairs, and storm damage restoration across Saskatchewan."
        canonical="/services"
        schemaJson={[servicesSchema]}
      />
      <section className="relative py-32 text-primary-foreground overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://wsrv.nl/?url=https://vibe.filesafe.space/1783106672919603654/assets/33163f38-c210-4bd6-a3f9-119d4d9972a8.png&output=webp&q=60"
            alt="Saskatchewan Roofing Services"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
        </div>
        <div className="container relative px-4 z-10">
          <div className="max-w-3xl space-y-6">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white drop-shadow-md">
              Roofing Services in Saskatchewan
            </h1>
            <div className="space-y-4 text-white/90 drop-shadow-sm">
              <p className="text-xl font-medium leading-relaxed">
                Homeowners in Saskatchewan need a roofing contractor who truly
                understands the extreme local climate. From freezing -40°C
                winters in Prince Albert to blistering +35°C summers in Estevan,
                heavy snow loads, and sudden, destructive prairie hailstorms
                across the Moose Jaw-Regina corridor, your roof is your home's
                most critical line of defense. A generic roofing solution
                designed for milder climates simply won't survive here.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stat Callout Grid */}
      <section className="bg-primary text-primary-foreground py-8 border-b">
        <div className="container px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center divide-y md:divide-y-0 md:divide-x divide-primary-foreground/20">
            <div className="py-4 md:py-0 space-y-2">
              <div className="text-4xl font-bold text-accent">2,500+</div>
              <div className="font-medium text-primary-foreground/80 uppercase tracking-wider text-sm">
                Roofs Completed
              </div>
            </div>
            <div className="py-4 md:py-0 space-y-2">
              <div className="text-4xl font-bold text-accent">15+</div>
              <div className="font-medium text-primary-foreground/80 uppercase tracking-wider text-sm">
                Years in Business
              </div>
            </div>
            <div className="py-4 md:py-0 space-y-2">
              <div className="text-4xl font-bold text-accent">
                4.9<span className="text-2xl">★</span>
              </div>
              <div className="font-medium text-primary-foreground/80 uppercase tracking-wider text-sm">
                Average Rating
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-muted/30">
        <div className="container px-4 max-w-6xl mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              A Different Kind of Roofing Company
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              We approach every project with the specific demands of
              Saskatchewan weather in mind. We do things differently than
              national chains or fly-by-night contractors who disappear after
              the storm season.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-background p-8 rounded-2xl border shadow-sm space-y-4">
              <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center">
                <ShieldCheck className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-foreground">
                No High-Pressure Sales
              </h3>
              <p className="text-muted-foreground">
                Just honest, straightforward advice from local experts who live
                and work in your community. We empower you to make the right
                choice for your home.
              </p>
            </div>
            <div className="bg-background p-8 rounded-2xl border shadow-sm space-y-4">
              <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center">
                <FileText className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-foreground">
                Fixed Pricing in Writing
              </h3>
              <p className="text-muted-foreground">
                The price on your contract is exactly the price you pay, with
                zero hidden surprises or sudden material upcharges.
              </p>
            </div>
            <div className="bg-background p-8 rounded-2xl border shadow-sm space-y-4">
              <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center">
                <Hammer className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-foreground">
                Climate-Tested Materials
              </h3>
              <p className="text-muted-foreground">
                We exclusively use materials proven to endure our harsh
                environment, installed by certified crews who don't cut corners.
              </p>
            </div>
          </div>
          <div className="mt-12 text-center max-w-3xl mx-auto">
            <p className="text-lg text-muted-foreground font-medium">
              With over 2,500 roofs successfully completed and 15+ years of
              dedicated service to homeowners province-wide, we bring
              unparalleled local expertise, premium craftsmanship, and real,
              enforceable warranties to every single job. When you choose Sask
              Roofing Company, you're choosing peace of mind that lasts for
              decades.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background">
        <div className="container px-4 max-w-4xl mx-auto">
          <div className="space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              Choosing the Right Service for Your Roof
            </h2>

            {/* TL;DR Box */}
            <div className="bg-primary/5 border-l-4 border-primary p-6 rounded-r-lg my-8">
              <div className="flex items-start gap-4">
                <Info className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-bold text-lg mb-2">
                    TL;DR: Repair or Replace?
                  </h3>
                  <p className="text-muted-foreground">
                    If your roof is under 15 years old and has isolated damage
                    (like a few blown-off shingles), a{" "}
                    <Link
                      to="/services/repair"
                      className="text-primary font-medium hover:underline"
                    >
                      repair
                    </Link>{" "}
                    is likely sufficient. If it's over 20 years old,
                    experiencing widespread granule loss, or has multiple active
                    leaks, it's time for a{" "}
                    <Link
                      to="/services/replacement"
                      className="text-primary font-medium hover:underline"
                    >
                      full replacement
                    </Link>
                    . Our free inspection provides the exact answer with zero
                    guesswork.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
              <p>
                Knowing whether you need a minor repair or a complete roof
                replacement isn't always obvious from the ground. Age is a major
                factor—if your asphalt shingle roof is approaching that 20-year
                mark, the materials are likely reaching the end of their
                functional lifespan, and it's time to start planning for a
                replacement before a major failure occurs.
              </p>

              <div className="space-y-4 my-8">
                <h3 className="text-xl font-bold text-foreground flex items-center gap-2">
                  <AlertTriangle className="w-5 h-5 text-accent" />3 Warning
                  Signs You Need Immediate Attention
                </h3>
                <ul className="space-y-4">
                  <li className="flex gap-4">
                    <span className="text-3xl font-bold text-primary/20 leading-none">
                      01
                    </span>
                    <div>
                      <strong className="text-foreground block">
                        Excessive Granule Loss
                      </strong>
                      Check your gutters after a heavy rain. If they are filled
                      with coarse, sand-like granules, your shingles are losing
                      their protective coating and UV resistance.
                    </div>
                  </li>
                  <li className="flex gap-4">
                    <span className="text-3xl font-bold text-primary/20 leading-none">
                      02
                    </span>
                    <div>
                      <strong className="text-foreground block">
                        Curling or Clawing Shingles
                      </strong>
                      Shingles that curl up at the edges or buckle in the middle
                      indicate poor attic ventilation or advanced age, leaving
                      your roof highly vulnerable to wind uplift.
                    </div>
                  </li>
                  <li className="flex gap-4">
                    <span className="text-3xl font-bold text-primary/20 leading-none">
                      03
                    </span>
                    <div>
                      <strong className="text-foreground block">
                        Interior Water Stains
                      </strong>
                      Brown spots on your ceiling or walls mean water has
                      already penetrated the roofing system, the underlayment,
                      and the decking. This requires immediate emergency repair.
                    </div>
                  </li>
                </ul>
              </div>

              <p>
                When severe weather strikes, our storm and hail emergency call
                flow is designed to protect your home fast. If you suspect hail
                or wind damage, reach out to us before calling your insurance.
                We'll provide a comprehensive assessment, secure any active
                leaks with emergency tarping, and document the damage thoroughly
                to help streamline your insurance claim process.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-muted/30 border-y">
        <div className="container px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
                Climate-Tested, Saskatchewan-Built
              </h2>
              <div className="space-y-4 text-lg text-muted-foreground leading-relaxed">
                <p>
                  We don&apos;t just nail down shingles; we engineer complete
                  roofing systems built specifically for the prairies. We use
                  premium architectural shingles that are rigorously rated to
                  withstand high winds of 130+ km/h (Class F wind resistance),
                  preventing catastrophic blow-offs during intense summer
                  storms. We also offer Class 4 impact-resistant options
                  specifically designed for Saskatchewan&apos;s notorious hail
                  alleys.
                </p>
                <p>
                  To combat our brutal winters, we install high-quality
                  synthetic underlayment and heavy-duty ice and water shield
                  membranes along all eaves, valleys, and vulnerable penetration
                  points (like chimneys and vents). This critical waterproof
                  layer stops ice damming in its tracks, preventing melting snow
                  from backing up under the shingles and leaking into your home
                  during the spring thaw.
                </p>
                <p>
                  Furthermore, we focus heavily on proper attic ventilation
                  engineering. A well-ventilated roof is essential for managing
                  the extreme temperature swings from -40°C winters to +35°C
                  summers. Balanced intake and exhaust ventilation prevents
                  winter condensation and moisture buildup, prevents summer heat
                  from baking your shingles from the inside out, and keeps your
                  home energy-efficient year-round.
                </p>

                <div className="mt-6 p-4 bg-background border rounded-lg inline-flex items-center gap-3 shadow-sm">
                  <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0" />
                  <span className="text-sm font-medium text-foreground">
                    Exceeds Saskatchewan building codes for wind uplift and snow
                    load requirements.
                  </span>
                </div>
              </div>
            </div>
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-full min-h-[400px]">
              <img
                src="https://wsrv.nl/?url=https://vibe.filesafe.space/1783106672919603654/assets/c04423b6-ebfa-4d50-936c-db3e654f5d83.png&output=webp&q=60"
                alt="Premium architectural asphalt shingle roof installation in Saskatchewan"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Process Timeline */}
      <section className="py-16 md:py-24 bg-background">
        <div className="container px-4">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              Our Proven 4-Step Process
            </h2>
            <p className="text-lg text-muted-foreground">
              We make replacing or repairing your roof as straightforward and
              stress-free as possible.
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-8 relative">
            <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-0.5 bg-border -z-10"></div>

            <div className="relative space-y-4 bg-background pt-2 text-center md:text-left">
              <div className="w-16 h-16 bg-primary text-primary-foreground rounded-full flex items-center justify-center border-4 border-background mx-auto md:mx-0 shadow-sm">
                <Search className="w-6 h-6 text-accent" />
              </div>
              <h3 className="text-xl font-bold">1. Free Inspection</h3>
              <p className="text-muted-foreground">
                We start with a thorough, no-obligation inspection to assess
                your roof&apos;s condition and identify any underlying issues.
              </p>
            </div>

            <div className="relative space-y-4 bg-background pt-2 text-center md:text-left">
              <div className="w-16 h-16 bg-primary text-primary-foreground rounded-full flex items-center justify-center border-4 border-background mx-auto md:mx-0 shadow-sm">
                <FileText className="w-6 h-6 text-accent" />
              </div>
              <h3 className="text-xl font-bold">2. Custom Quote</h3>
              <p className="text-muted-foreground">
                You receive a detailed, fixed-price written quote along with
                expert guidance on selecting the right materials for your home.
              </p>
            </div>

            <div className="relative space-y-4 bg-background pt-2 text-center md:text-left">
              <div className="w-16 h-16 bg-primary text-primary-foreground rounded-full flex items-center justify-center border-4 border-background mx-auto md:mx-0 shadow-sm">
                <Hammer className="w-6 h-6 text-accent" />
              </div>
              <h3 className="text-xl font-bold">3. Installation</h3>
              <p className="text-muted-foreground">
                Our experienced local crews install your new roof efficiently,
                typically completing residential projects in 1 to 2 days.
              </p>
            </div>

            <div className="relative space-y-4 bg-background pt-2 text-center md:text-left">
              <div className="w-16 h-16 bg-primary text-primary-foreground rounded-full flex items-center justify-center border-4 border-background mx-auto md:mx-0 shadow-sm">
                <ShieldCheck className="w-6 h-6 text-accent" />
              </div>
              <h3 className="text-xl font-bold">4. Final Walkthrough</h3>
              <p className="text-muted-foreground">
                We conduct a final inspection with you to ensure complete
                satisfaction, backed by our solid workmanship warranty.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Material Comparison Table */}
      <section className="py-16 md:py-24 bg-muted/30 border-y">
        <div className="container px-4 max-w-5xl mx-auto">
          <div className="text-center mb-12 space-y-4">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              Roofing Material Comparison
            </h2>
            <p className="text-lg text-muted-foreground">
              Compare your options to find the perfect fit for your home and
              budget.
            </p>
          </div>
          <div className="overflow-x-auto rounded-xl border bg-background shadow-sm">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-primary text-primary-foreground">
                  <th className="p-4 font-bold border-b border-primary-foreground/20 w-1/4">
                    Feature
                  </th>
                  <th className="p-4 font-bold border-b border-primary-foreground/20 w-1/4">
                    Asphalt Shingles
                  </th>
                  <th className="p-4 font-bold border-b border-primary-foreground/20 w-1/4">
                    Metal Roofing
                  </th>
                  <th className="p-4 font-bold border-b border-primary-foreground/20 w-1/4">
                    Roof Repair
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                <tr className="hover:bg-muted/50 transition-colors">
                  <td className="p-4 font-medium text-foreground">
                    Initial Cost
                  </td>
                  <td className="p-4 text-muted-foreground">
                    $$ (Most Affordable)
                  </td>
                  <td className="p-4 text-muted-foreground">
                    $$$$ (Premium Investment)
                  </td>
                  <td className="p-4 text-muted-foreground">
                    $ (Budget Friendly)
                  </td>
                </tr>
                <tr className="hover:bg-muted/50 transition-colors">
                  <td className="p-4 font-medium text-foreground">
                    Expected Lifespan
                  </td>
                  <td className="p-4 text-muted-foreground">20 - 30 Years</td>
                  <td className="p-4 text-muted-foreground">50+ Years</td>
                  <td className="p-4 text-muted-foreground">
                    Extends Current Life
                  </td>
                </tr>
                <tr className="hover:bg-muted/50 transition-colors">
                  <td className="p-4 font-medium text-foreground">
                    Climate Fit (SK)
                  </td>
                  <td className="p-4 text-muted-foreground">
                    Excellent (High-wind rated)
                  </td>
                  <td className="p-4 text-muted-foreground">
                    Superior (Sheds snow/ice)
                  </td>
                  <td className="p-4 text-muted-foreground">Targeted Fixes</td>
                </tr>
                <tr className="hover:bg-muted/50 transition-colors">
                  <td className="p-4 font-medium text-foreground">
                    Hail Resistance
                  </td>
                  <td className="p-4 text-muted-foreground">
                    Good (Class 3/4 available)
                  </td>
                  <td className="p-4 text-muted-foreground">
                    Exceptional (Won&apos;t crack)
                  </td>
                  <td className="p-4 text-muted-foreground">N/A</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="py-20 bg-background">
        <div className="container px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <Link key={service.id} to={service.link} className="group block">
                <div className="bg-muted/30 rounded-xl border overflow-hidden transition-all hover:shadow-lg hover:border-primary h-full flex flex-col">
                  <div className="h-48 overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-6 flex-1 flex flex-col space-y-4">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-primary/5 rounded-lg text-primary">
                        <service.icon className="w-6 h-6" />
                      </div>
                      <h2 className="text-xl font-bold group-hover:text-primary transition-colors">
                        {service.title}
                      </h2>
                    </div>
                    <p className="text-muted-foreground flex-1">
                      {service.desc}
                    </p>
                    <div className="text-primary font-medium flex items-center gap-2 pt-2">
                      Learn More <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-muted/30 border-t">
        <div className="container px-4 text-center max-w-3xl mx-auto space-y-8">
          <h2 className="text-3xl font-bold">Not sure what you need?</h2>
          <p className="text-lg text-muted-foreground">
            The best way to know the condition of your roof is to have a
            professional take a look. We offer free, no-pressure inspections
            across Saskatchewan.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button
              size="lg"
              className="bg-accent text-accent-foreground hover:bg-accent/90 text-lg px-8 py-6 h-auto"
              asChild
            >
              <Link to="/contact">Get a Free Inspection</Link>
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="text-lg px-8 py-6 h-auto"
              asChild
            >
              <Link to="/process">See Our Process</Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
